export default "__VITE_ASSET__C6u6avKf__"